import { LOCATION_CHANGE as ROUTER_LOCATION_CHANGE } from 'connected-react-router';
import { types as identityTypes } from '@clearscore/redux.identity';
import { types as negativeFactorTypes } from '@clearscore/redux.negative-factor';
import { types as mortgageQuoteTypes } from '@clearscore/redux.mortgage-quote';
import { types as timeMachineTypes } from '@clearscore/redux.time-machine';
import { types as energyTypes } from '@clearscore/redux.energy';
import { types as productVerticalTypes } from '@clearscore/redux.product-vertical';
import { types as remortgageTypes } from '@clearscore/redux.product-remortgage';
import { types as profileTypes } from '@clearscore/redux.profile';
import { types as webappTrackingActions } from '@clearscore/redux.webapp-tracking-actions';
import { types as dynamicFormJourneyTypes } from '@clearscore/redux.dynamic-form-journey';
import { types as productsTypes } from '@clearscore/redux.products';
import { types as protectTypes } from '@clearscore/redux.protect';
import { types as resolveTypes } from '@clearscore/redux.resolve';

import {
    REPORT_FACTOR_CTA_CLICKED,
    MORTGAGE_REFINE,
    ENERGY_PRODUCT_PICKER_CLICK,
    TIME_MACHINE_DATE_CLICK,
    TIME_MACHINE_DATE_VIEW,
    REPORT_OVERVIEW_SEE_DETAILS_CLICK,
    FIRST_TIME_LOGIN,
    ENERGY_STAGE_CHANGED,
    ENERGY_OFFERS_FETCH_EVENT,
    ENERGY_HOME_VIEW_EVENT,
    PRODUCT_VERTICAL_CLICK,
    REMORTGAGE_REFINE_VISIT,
    REMORTGAGE_REFINE_SUBMIT,
    IDENTIFY_EVENT,
    ROUTE_CHANGE_EVENT,
    DONUT_CLICK,
    TRACK_CLICKABLE_HELP_CLICK,
    DYNAMIC_FORM_GO_BACK,
    DYNAMIC_FORM_START_FAIL,
    DYNAMIC_FORM_NEXT_FAIL,
    PRODUCT_APPLY_CLICK,
    PRODUCT_FETCH_FAILURE,
    FIRST_TIME_VISIT_EVENT,
    PRODUCT_NAVIGATION_CLICK,
    REPORT_ACCOUNT_DETAILS_OPEN,
    REPORT_ACCOUNT_DETAILS_CLICK,
    REPORT_ACCOUNT_PAYMENT_HISTORY_CLICK,
    MARKETING_CAMPAIGN_REFERRER,
    TRACK_PRODUCT_TOGGLE_CLICK,
    TRACK_PREAPPROVED_TOGGLE_CLICK,
    VERIFY_EMAIL_EVENT,
    DOC_UPLOAD_ATTEMPT,
    DUPLOCK_CTA_CLICK,
    MANUAL_ADDRESS_ENTRY_CLICK,
    PRODUCT_INTERSTITIAL_PROGRESSION,
    PRODUCT_INTERSTITIAL_COPY_CTA_CLICK,
    PRODUCT_FILTER_APPLIED,
    PRODUCT_FILTER_CLICK,
    PRODUCT_FILTER_UPDATED,
    PROTECT_WELCOME_CLICK,
    PROTECT_EMAIL_VERIFY_CLICK,
    PROTECT_BENEFITS_CLICK,
    PROTECT_PAYMENT_SUCCESS_CLICK,
    PROTECT_ACTION_OPENED,
    DONUT_SLIDE_VIEWED,
    DYNAMIC_DASHBOARD_DONUT_CLICKED,
} from './events';
import * as resolveEvents from './events/resolve';

export default {
    [negativeFactorTypes.NEGATIVE_FACTOR_CTA_CLICKED]: [REPORT_FACTOR_CTA_CLICKED],
    [mortgageQuoteTypes.QUOTE_REFINE]: [MORTGAGE_REFINE],
    'CS/PRODUCT/ENERGY_PRODUCT_PICKER_CLICK': [ENERGY_PRODUCT_PICKER_CLICK], // used by legacy client-app
    [timeMachineTypes.REPORT_OVERVIEW_VIEW_EVENT]: [TIME_MACHINE_DATE_CLICK, TIME_MACHINE_DATE_VIEW],
    [timeMachineTypes.REPORT_OVERVIEW_SEE_DETAILS_CLICK_EVENT]: [REPORT_OVERVIEW_SEE_DETAILS_CLICK],
    [timeMachineTypes.REPORT_INFORMATION_BACK_CLICK_EVENT]: [REPORT_OVERVIEW_SEE_DETAILS_CLICK],
    [identityTypes.IDENTITY_FIRST_TIME_REGISTRATION]: [FIRST_TIME_LOGIN],
    [energyTypes.ENERGY_STAGE_CHANGED]: [ENERGY_STAGE_CHANGED],
    [energyTypes.ENERGY_OFFERS_FETCH_EVENT]: [ENERGY_OFFERS_FETCH_EVENT],
    [energyTypes.ENERGY_HOME_VIEW_EVENT]: [ENERGY_HOME_VIEW_EVENT],
    [productVerticalTypes.PRODUCT_VERTICAL_CLICK]: [PRODUCT_VERTICAL_CLICK],
    [remortgageTypes.REMORTGAGE_ELIGIBILITY_FETCH]: [REMORTGAGE_REFINE_VISIT],
    [remortgageTypes.REMORTGAGE_PRODUCTS_FETCH]: [REMORTGAGE_REFINE_SUBMIT],
    [profileTypes.PROFILE_FETCH_SUCCESS]: [IDENTIFY_EVENT],
    [profileTypes.PROFILE_RESEND_EMAIL_VERIFICATION]: [VERIFY_EMAIL_EVENT],
    [ROUTER_LOCATION_CHANGE]: [ROUTE_CHANGE_EVENT],
    [webappTrackingActions.TRACK_DONUT_CLICK]: [DONUT_CLICK],
    [webappTrackingActions.TRACK_CLICKABLE_HELP_CLICK]: [TRACK_CLICKABLE_HELP_CLICK],
    [webappTrackingActions.TRACK_PRODUCT_TOGGLE_CLICK]: [TRACK_PRODUCT_TOGGLE_CLICK],
    [webappTrackingActions.TRACK_PREAPPROVED_TOGGLE_CLICK]: [TRACK_PREAPPROVED_TOGGLE_CLICK],
    [dynamicFormJourneyTypes.GO_BACK]: [DYNAMIC_FORM_GO_BACK],
    [dynamicFormJourneyTypes.SCHEMA_FETCH_ERROR]: [DYNAMIC_FORM_START_FAIL],
    [dynamicFormJourneyTypes.SCHEMA_SUBMIT_ERROR]: [DYNAMIC_FORM_NEXT_FAIL],
    [webappTrackingActions.TRACK_DYNAMIC_FORMS_GO_BACK]: [DYNAMIC_FORM_GO_BACK],
    [webappTrackingActions.TRACK_DYNAMIC_FORMS_START_ERROR]: [DYNAMIC_FORM_START_FAIL],
    [webappTrackingActions.TRACK_DYNAMIC_FORMS_NEXT_ERROR]: [DYNAMIC_FORM_NEXT_FAIL],
    [productsTypes.PRODUCTS_APPLY_CLICK]: [PRODUCT_APPLY_CLICK],
    [productsTypes.PRODUCTS_FETCH_FAILURE]: [PRODUCT_FETCH_FAILURE],
    [identityTypes.IDENTITY_FIRST_TIME_VISIT]: [FIRST_TIME_VISIT_EVENT],
    [identityTypes.IDENTITY_MARKETING_USER]: [MARKETING_CAMPAIGN_REFERRER],
    [webappTrackingActions.TRACK_PRODUCT_NAVIGATION_CLICK]: [PRODUCT_NAVIGATION_CLICK],
    [webappTrackingActions.TRACK_REPORT_ACCOUNT_DETAILS_OPEN]: [REPORT_ACCOUNT_DETAILS_OPEN],
    [webappTrackingActions.TRACK_REPORT_ACCOUNT_DETAILS_CLICK]: [REPORT_ACCOUNT_DETAILS_CLICK],
    [webappTrackingActions.TRACK_REPORT_ACCOUNT_PAYMENT_HISTORY_CLICK]: [REPORT_ACCOUNT_PAYMENT_HISTORY_CLICK],
    [webappTrackingActions.TRACK_DOC_UPLOAD_ATTEMPT]: [DOC_UPLOAD_ATTEMPT],
    [webappTrackingActions.TRACK_DUPLOCK_CTA_CLICK]: [DUPLOCK_CTA_CLICK],
    [webappTrackingActions.TRACK_MANUAL_ADDRESS_ENTRY_CLICK]: [MANUAL_ADDRESS_ENTRY_CLICK],
    [webappTrackingActions.TRACK_PRODUCT_INTERSTITIAL_PROGRESSION]: [PRODUCT_INTERSTITIAL_PROGRESSION],
    [webappTrackingActions.TRACK_PRODUCT_INTERSTITIAL_COPY_CTA_CLICK]: [PRODUCT_INTERSTITIAL_COPY_CTA_CLICK],
    [webappTrackingActions.TRACK_PRODUCT_FILTER_APPLIED]: [PRODUCT_FILTER_APPLIED],
    [webappTrackingActions.TRACK_PRODUCT_FILTER_CLICK]: [PRODUCT_FILTER_CLICK],
    [webappTrackingActions.TRACK_PRODUCT_FILTER_UPDATED]: [PRODUCT_FILTER_UPDATED],
    [protectTypes.PROTECT_WELCOME_CTA_CLICK]: [PROTECT_WELCOME_CLICK],
    [protectTypes.PROTECT_EMAIL_VERIFY_CLICK]: [PROTECT_EMAIL_VERIFY_CLICK],
    [protectTypes.PROTECT_BENEFITS_CLICK]: [PROTECT_BENEFITS_CLICK],
    [protectTypes.PROTECT_PAYMENT_SUCCESS_CLICK]: [PROTECT_PAYMENT_SUCCESS_CLICK],
    [protectTypes.PROTECT_ACTION_OPENED]: [PROTECT_ACTION_OPENED],
    [webappTrackingActions.TRACK_DONUT_SLIDE_VIEWED]: [DONUT_SLIDE_VIEWED],
    [webappTrackingActions.TRACK_DYNAMIC_DASHBOARD_DONUT_CLICKED]: [DYNAMIC_DASHBOARD_DONUT_CLICKED],
    [resolveTypes.TRACK_RESOLVE_FAQ_OPEN]: [resolveEvents.RESOLVE_HELP_TOOLTIP_CLICKED],
    [resolveTypes.TRACK_RESOLVE_FAQ_LINK_CLICKED]: [resolveEvents.RESOLVE_FAQ_LINK_CLICKED],
    [resolveTypes.TRACK_RESOLVE_OPTION_CLICKED]: [resolveEvents.RESOLVE_OPTIONS_LIST_OPTION_CLICKED],
    [resolveTypes.TRACK_RESOLVE_OPTION_CTA_CLICKED]: [resolveEvents.RESOLVE_OPTION_SCREEN_CTA_CLICKED],
    [resolveTypes.TRACK_RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED]: [
        resolveEvents.RESOLVE_VIEW_ALL_MISSED_PAYMENTS_CLICKED,
    ],
    [resolveTypes.TRACK_RESOLVE_COACHING_CTA_CLICKED]: [resolveEvents.RESOLVE_NO_MISSED_PAYMENTS_COACHING_CTA_CLICKED],
    [resolveTypes.TRACK_RESOLVE_SPINNER_SHOWN]: [resolveEvents.RESOLVE_SPINNER_SHOWN],
    [resolveTypes.TRACK_RESOLVE_HELP_ARTICLE_CLICKED]: [resolveEvents.RESOLVE_HELP_ARTICLE_CLICKED],
    [resolveTypes.TRACK_RESOLVE_LANDING_SCREEN_CTA_CLICKED]: [resolveEvents.RESOLVE_LANDING_SCREEN_CTA_CLICKED],
};
